import React, { useState } from "react";
import {
  Col,
  Row,
  Card,
  Form,
  FormGroup,
  Label,
  Input,
  CardBody,
  InputGroup,
  InputGroupText,
} from "reactstrap";
import FootprintInputButton from "../../../Components/utils/FootprintInputButton";
import FootprintDatePicker from "../../../Components/utils/FootprintDatePicker";
import moment from "moment";
import { DEFAULT_FORMAT } from "../../../Components/utils/FootprintDatePicker";
import { useRequestProcessor } from "../../../requestProcessor";

import { useNavigate } from "react-router-dom";
import { submitExtendedDaycare } from "../../../QueryFunctions/queryfunction";
import { StyledCardHeader } from "../TakeABreak/styles";
import SpinnerLoading from "../../../Components/utils/SpinnerLoading";
import { FaAngleDown } from "react-icons/fa";
import { mobileAtom } from "../../../AtomStore/store";
import { useAtom } from "jotai";

const ExtendedDaycare = () => {
  const navigate = useNavigate();

  const { useMutationWrapper } = useRequestProcessor();
  const durationValues = [
    { key: "Monthly", value: "1 Month" },
    { key: "Weekly", value: "1 Week" },
    { key: "Daily", value: "1 Day" },
  ];

  const [selectedDate, setSelectedDate] = useState();
  const [serviceDuration, setserviceDuration] = useState();
  const [holidaySelected, setHolidaySelected] = useState();
  const [error, setError] = useState();

  const extendedDaycare = useMutationWrapper("extendedDaycare", () =>
    submitExtendedDaycare(selectedDate, serviceDuration, navigate)
  );
  const validate = () => {
    if (holidaySelected === true) {
      setError("The Selected Date Cannot Be a Holiday");

      return false;
    } else if (selectedDate === undefined) {
      setError("Please Select Date");

      return false;
    } else if (serviceDuration === undefined || serviceDuration === "") {
      setError("Please Select Program");

      return false;
    } else {
      return true;
    }
  };

  const submit = () => {
    // alert(this.state.serviceDuration);
    if (validate()) {
      // this.props.showPasswordOverlay(true, isMatched => {
      //   if (isMatched) {
      extendedDaycare.mutate();
    } else {
    }
    // });
    // }
  };
  return (
    <div className="m-[10px] mt-[20px]">
      {extendedDaycare.isLoading && <SpinnerLoading />}

      <div className="bg-white rounded-lg shadow-md p-2">
        <form className="md:p-4 space-y-4 pb-4">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            {/* Select Type */}
            <div>
              <label className="block text-sm font-medium text-black mb-2">
                Select Type
              </label>
              <div className="relative rounded-sm">
                <select
                  className="w-full appearance-none p-2 bg-white"
                  onChange={(event) => {
                    setError(undefined);
                    setserviceDuration(event.target.value);
                  }}
                >
                  <option value="">--Select--</option>
                  {durationValues?.map((item, i) => (
                    <option key={i} value={item.value}>
                      {item.key}
                    </option>
                  ))}
                </select>
                <FaAngleDown className="pointer-events-none absolute inset-y-0 right-4 flex items-center text-xl" />
              </div>
            </div>
            <hr className=" mx-2 mt-2  bg-black" />

            {/* Start Date */}
            <div>
              <label className="block text-sm font-medium text-black mb-2">
                Start Date
              </label>
              <div className="flex items-center">
                <FootprintDatePicker
                  holidaySelected={(selected) => {
                    setError("The selected Date Cannot Be a Holiday");
                    setHolidaySelected(selected);
                  }}
                  inputProps={{ placeholder: "Select Date" }}
                  minimumDate={moment()}
                  onChange={(date) => {
                    setHolidaySelected(false);
                    setSelectedDate(moment(date).format(DEFAULT_FORMAT));
                    setError(undefined);
                  }}
                />
                <i className="icon-calender text-2xl text-black mr-2" />
              </div>
            </div>
          </div>

          {/* Error Message */}
          {error && <div className="text-red-500 text-sm">{error}</div>}

          {/* Submit Button */}
          <div className="text-center">
            <FootprintInputButton
              className="bg-primary text-white px-6 py-2 rounded-md hover:bg-primary-dark"
              onClick={submit}
            >
              Submit
            </FootprintInputButton>
          </div>
        </form>
      </div>
    </div>
  );
};

export default ExtendedDaycare;
